import { DeactivatedUsersTable } from 'src/features/userManagement/components/table/DeactivatedUsersTable';

const DeactivatedUsers = () => {
    return <DeactivatedUsersTable />;
};

export default DeactivatedUsers;
